import { render, staticRenderFns } from "./ModalCertificate.vue?vue&type=template&id=6f034a51"
import script from "./ModalCertificate.vue?vue&type=script&lang=js"
export * from "./ModalCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports